var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.5V20.38C14.54 20.68 14.44 21 14.21 21.21C14.1175 21.3027 14.0076 21.3762 13.8866 21.4264C13.7657 21.4766 13.636 21.5024 13.505 21.5024C13.374 21.5024 13.2444 21.4766 13.1234 21.4264C13.0024 21.3762 12.8925 21.3027 12.8 21.21L10.79 19.2C10.681 19.0933 10.5981 18.9629 10.5478 18.819C10.4975 18.675 10.4812 18.5213 10.5 18.37V12.5H10.47L4.71001 5.12C4.54762 4.91153 4.47434 4.64726 4.5062 4.38493C4.53805 4.1226 4.67244 3.88355 4.88001 3.72C5.07001 3.58 5.28001 3.5 5.50001 3.5H19.5C19.72 3.5 19.93 3.58 20.12 3.72C20.3276 3.88355 20.462 4.1226 20.4938 4.38493C20.5257 4.64726 20.4524 4.91153 20.29 5.12L14.53 12.5H14.5Z",
    fill: "#959BA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.21c5992cc54038a5afbe1c4e2a69a9b5.svg";
export { ForwardRef as ReactComponent };